import React from "react"
import { LoadingOutlined } from "@ant-design/icons"

import styles from "./Spin.module.less"

export const Spin = (): JSX.Element => {
  return <LoadingOutlined className={styles.spin} spin />
}
